export default __webpack_public_path__ + "static/media/team5.b7477812.png";